/**
 * Hydrogen Theme
 */

import hexrgb from 'hex-rgb'

// noinspection SpellCheckingInspection
const hydrogen = {
  themes: {
    dark: {},
    light: {},
  },
  colors: {
    white: {
      name: 'white',
      hex: 'ffffff',
      palette: ['monochrome'],
      get rgb() {
        const result = hexrgb(this.hex, { format: 'array' })
        return result.slice(0, 3).join(', ')
      },
      roles: {
        dark: ['white'],
        light: ['clear', 'white'],
      },
    },
    nearwhite: {
      name: 'nearwhite',
      hex: 'fbfbfb',
      palette: ['monochrome'],
      get rgb() {
        const result = hexrgb(this.hex, { format: 'array' })
        return result.slice(0, 3).join(', ')
      },
      roles: {
        dark: ['nearwhite'],
        light: ['nearwhite', 'shaded'],
      },
    },
    offwhite: {
      name: 'offwhite',
      hex: 'f2f4f5',
      palette: ['monochrome'],
      get rgb() {
        const result = hexrgb(this.hex, { format: 'array' })
        return result.slice(0, 3).join(', ')
      },
      roles: {
        dark: ['offwhite'],
        light: ['offwhite'],
      },
    },
    icewhite: {
      name: 'icewhite',
      hex: 'eef5fa',
      palette: ['monochrome'],
      get rgb() {
        const result = hexrgb(this.hex, { format: 'array' })
        return result.slice(0, 3).join(', ')
      },
      roles: {
        dark: ['icewhite'],
        light: ['icewhite', 'iced'],
      },
    },
    coolbeige: {
      name: 'coolbeige',
      hex: 'ededf2',
      palette: ['monochrome'],
      get rgb() {
        const result = hexrgb(this.hex, { format: 'array' })
        return result.slice(0, 3).join(', ')
      },
      roles: {
        dark: ['coolbeige'],
        light: ['coolbeige', 'opaque'],
      },
    },
    vuetifygray: {
      name: 'vuetifygray',
      hex: '9e9e9e',
      palette: ['monochrome'],
      get rgb() {
        const result = hexrgb(this.hex, { format: 'array' })
        return result.slice(0, 3).join(', ')
      },
      roles: {
        dark: ['vuetifygray', 'midtone'],
        light: ['vuetifygray'],
      },
    },
    midgray: {
      name: 'midgray',
      hex: 'a5b1b9',
      palette: ['monochrome'],
      get rgb() {
        const result = hexrgb(this.hex, { format: 'array' })
        return result.slice(0, 3).join(', ')
      },
      roles: {
        dark: ['midgray'],
        light: ['midgray'],
      },
    },
    gray: {
      name: 'gray',
      hex: '647b8d',
      palette: ['monochrome'],
      get rgb() {
        const result = hexrgb(this.hex, { format: 'array' })
        return result.slice(0, 3).join(', ')
      },
      roles: {
        dark: ['gray'],
        light: ['gray'],
      },
    },
    coolgray: {
      name: 'coolgray',
      hex: '5e6769',
      palette: ['monochrome'],
      get rgb() {
        const result = hexrgb(this.hex, { format: 'array' })
        return result.slice(0, 3).join(', ')
      },
      roles: {
        dark: ['coolgray'],
        light: ['coolgray'],
      },
    },
    black: {
      name: 'black',
      hex: '000c15',
      palette: ['monochrome'],
      get rgb() {
        const result = hexrgb(this.hex, { format: 'array' })
        return result.slice(0, 3).join(', ')
      },
      roles: {
        dark: ['black', 'clear', 'iced'],
        light: ['black'],
      },
    },
    vuetifyblack: {
      name: 'vuetifyblack',
      hex: '1e1e1e',
      palette: ['monochrome'],
      get rgb() {
        const result = hexrgb(this.hex, { format: 'array' })
        return result.slice(0, 3).join(', ')
      },
      roles: {
        dark: ['vuetifyblack'],
        light: ['vuetifyblack'],
      },
    },
    vuetifyblackhighlight: {
      name: 'vuetifyblackhighlight',
      hex: '333333',
      palette: ['monochrome'],
      get rgb() {
        const result = hexrgb(this.hex, { format: 'array' })
        return result.slice(0, 3).join(', ')
      },
      roles: {
        dark: ['vuetifyblackhighlight'],
        light: ['vuetifyblackhighlight'],
      },
    },
    nearblack: {
      name: 'nearblack',
      hex: '051b2b',
      palette: ['monochrome'],
      get rgb() {
        const result = hexrgb(this.hex, { format: 'array' })
        return result.slice(0, 3).join(', ')
      },
      roles: {
        dark: ['nearblack'],
        light: ['nearblack'],
      },
    },
    blueblack: {
      name: 'blueblack',
      hex: '02355a',
      palette: ['monochrome'],
      get rgb() {
        const result = hexrgb(this.hex, { format: 'array' })
        return result.slice(0, 3).join(', ')
      },
      roles: {
        dark: ['blueblack', 'opaque'],
        light: ['blueblack'],
      },
    },
    darkestblue: {
      name: 'darkestblue',
      hex: '055289',
      palette: ['primary', 'monochrome'],
      get rgb() {
        const result = hexrgb(this.hex, { format: 'array' })
        return result.slice(0, 3).join(', ')
      },
      roles: {
        dark: ['darkestblue'],
        light: ['darkestblue'],
      },
    },
    darkblue: {
      name: 'darkblue',
      hex: '0062a8',
      palette: ['monochrome'],
      get rgb() {
        const result = hexrgb(this.hex, { format: 'array' })
        return result.slice(0, 3).join(', ')
      },
      roles: {
        dark: ['darkblue'],
        light: ['darkblue', 'midtone'],
      },
    },
    blue: {
      name: 'blue',
      hex: '007dd6',
      palette: ['primary', 'monochrome'],
      get rgb() {
        const result = hexrgb(this.hex, { format: 'array' })
        return result.slice(0, 3).join(', ')
      },
      roles: {
        dark: ['blue'],
        light: ['blue'],
      },
    },
    brightblue: {
      name: 'brightblue',
      hex: '0094ff',
      palette: ['monochrome', 'vibrant'],
      get rgb() {
        const result = hexrgb(this.hex, { format: 'array' })
        return result.slice(0, 3).join(', ')
      },
      roles: {
        dark: ['primary', 'brightblue'],
        light: ['primary', 'brightblue'],
      },
    },
    babyblue: {
      name: 'babyblue',
      hex: '00b6ff',
      palette: ['mood'],
      get rgb() {
        const result = hexrgb(this.hex, { format: 'array' })
        return result.slice(0, 3).join(', ')
      },
      roles: {
        dark: ['babyblue'],
        light: ['babyblue'],
      },
    },
    softblues: {
      name: 'softblues',
      hex: '00aed6',
      palette: ['mood'],
      get rgb() {
        const result = hexrgb(this.hex, { format: 'array' })
        return result.slice(0, 3).join(', ')
      },
      roles: {
        dark: ['softblues'],
        light: ['softblues'],
      },
    },
    offblue: {
      name: 'offblue',
      hex: '00d6d6',
      palette: ['primary', 'mood'],
      get rgb() {
        const result = hexrgb(this.hex, { format: 'array' })
        return result.slice(0, 3).join(', ')
      },
      roles: {
        dark: ['offblue'],
        light: ['offblue'],
      },
    },
    grassgreen: {
      name: 'grassgreen',
      hex: '5bcf70',
      palette: ['mood'],
      get rgb() {
        const result = hexrgb(this.hex, { format: 'array' })
        return result.slice(0, 3).join(', ')
      },
      roles: {
        dark: ['grassgreen'],
        light: ['grassgreen'],
      },
    },
    greenery: {
      name: 'greenery',
      hex: '66b461',
      palette: ['mood'],
      get rgb() {
        const result = hexrgb(this.hex, { format: 'array' })
        return result.slice(0, 3).join(', ')
      },
      roles: {
        dark: ['greenery'],
        light: ['greenery'],
      },
    },
    fuzzymoss: {
      name: 'fuzzymoss',
      hex: '5b9f77',
      palette: ['mood'],
      get rgb() {
        const result = hexrgb(this.hex, { format: 'array' })
        return result.slice(0, 3).join(', ')
      },
      roles: {
        dark: ['fuzzymoss'],
        light: ['fuzzymoss'],
      },
    },
    darkteal: {
      name: 'darkteal',
      hex: '5BA09F',
      palette: ['mood'],
      get rgb() {
        const result = hexrgb(this.hex, { format: 'array' })
        return result.slice(0, 3).join(', ')
      },
      roles: {
        dark: ['darkteal'],
        light: ['darkteal'],
      },
    },
    bluegreen: {
      name: 'bluegreen',
      hex: '00a88b',
      palette: ['mood'],
      get rgb() {
        const result = hexrgb(this.hex, { format: 'array' })
        return result.slice(0, 3).join(', ')
      },
      roles: {
        dark: ['bluegreen'],
        light: ['bluegreen'],
      },
    },
    retrogreen: {
      name: 'retrogreen',
      hex: '35d5a9',
      palette: ['mood'],
      get rgb() {
        const result = hexrgb(this.hex, { format: 'array' })
        return result.slice(0, 3).join(', ')
      },
      roles: {
        dark: ['retrogreen'],
        light: ['retrogreen'],
      },
    },
    retroyellow: {
      name: 'retroyellow',
      hex: 'ffef7f',
      palette: ['mood'],
      get rgb() {
        const result = hexrgb(this.hex, { format: 'array' })
        return result.slice(0, 3).join(', ')
      },
      roles: {
        dark: ['retroyellow'],
        light: ['retroyellow'],
      },
    },
    mellowyellow: {
      name: 'mellowyellow',
      hex: 'f8e459',
      palette: ['mood'],
      get rgb() {
        const result = hexrgb(this.hex, { format: 'array' })
        return result.slice(0, 3).join(', ')
      },
      roles: {
        dark: ['mellowyellow'],
        light: ['mellowyellow'],
      },
    },
    sunny: {
      name: 'sunny',
      hex: 'f8ce59',
      palette: ['mood'],
      get rgb() {
        const result = hexrgb(this.hex, { format: 'array' })
        return result.slice(0, 3).join(', ')
      },
      roles: {
        dark: ['sunny'],
        light: ['sunny'],
      },
    },
    orange: {
      name: 'orange',
      hex: 'ffaf4c',
      palette: ['mood'],
      get rgb() {
        const result = hexrgb(this.hex, { format: 'array' })
        return result.slice(0, 3).join(', ')
      },
      roles: {
        dark: ['orange'],
        light: ['orange'],
      },
    },
    redorange: {
      name: 'redorange',
      hex: 'fb834a',
      palette: ['mood'],
      get rgb() {
        const result = hexrgb(this.hex, { format: 'array' })
        return result.slice(0, 3).join(', ')
      },
      roles: {
        dark: ['redorange'],
        light: ['redorange'],
      },
    },
    toasted: {
      name: 'toasted',
      hex: 'e27362',
      palette: ['mood'],
      get rgb() {
        const result = hexrgb(this.hex, { format: 'array' })
        return result.slice(0, 3).join(', ')
      },
      roles: {
        dark: ['toasted'],
        light: ['toasted'],
      },
    },
    reds: {
      name: 'reds',
      hex: 'f85959',
      palette: ['mood'],
      get rgb() {
        const result = hexrgb(this.hex, { format: 'array' })
        return result.slice(0, 3).join(', ')
      },
      roles: {
        dark: ['reds'],
        light: ['reds'],
      },
    },
    retropink: {
      name: 'retropink',
      hex: 'f96f95',
      palette: ['mood'],
      get rgb() {
        const result = hexrgb(this.hex, { format: 'array' })
        return result.slice(0, 3).join(', ')
      },
      roles: {
        dark: ['retropink'],
        light: ['retropink'],
      },
    },
    lightpurple: {
      name: 'lightpurple',
      hex: 'c259f8',
      palette: ['mood'],
      get rgb() {
        const result = hexrgb(this.hex, { format: 'array' })
        return result.slice(0, 3).join(', ')
      },
      roles: {
        dark: ['lightpurple'],
        light: ['lightpurple'],
      },
    },
    wetgreen: {
      name: 'wetgreen',
      hex: '00bc10',
      palette: ['vibrant'],
      get rgb() {
        const result = hexrgb(this.hex, { format: 'array' })
        return result.slice(0, 3).join(', ')
      },
      roles: {
        dark: ['wetgreen'],
        light: ['wetgreen'],
      },
    },
    trueyellow: {
      name: 'trueyellow',
      hex: 'ffdf00',
      palette: ['vibrant'],
      get rgb() {
        const result = hexrgb(this.hex, { format: 'array' })
        return result.slice(0, 3).join(', ')
      },
      roles: {
        dark: ['trueyellow'],
        light: ['trueyellow'],
      },
    },
    orangey: {
      name: 'orangey',
      hex: 'ff8f04',
      palette: ['vibrant'],
      get rgb() {
        const result = hexrgb(this.hex, { format: 'array' })
        return result.slice(0, 3).join(', ')
      },
      roles: {
        dark: ['orangey'],
        light: ['orangey'],
      },
    },
    red: {
      name: 'red',
      hex: 'd82727',
      palette: ['vibrant'],
      get rgb() {
        const result = hexrgb(this.hex, { format: 'array' })
        return result.slice(0, 3).join(', ')
      },
      roles: {
        dark: ['red'],
        light: ['red'],
      },
    },
    pink: {
      name: 'pink',
      hex: 'e21a91',
      palette: ['vibrant'],
      get rgb() {
        const result = hexrgb(this.hex, { format: 'array' })
        return result.slice(0, 3).join(', ')
      },
      roles: {
        dark: ['pink'],
        light: ['pink'],
      },
    },
    purple: {
      name: 'purple',
      hex: '9d59f8',
      palette: ['vibrant'],
      get rgb() {
        const result = hexrgb(this.hex, { format: 'array' })
        return result.slice(0, 3).join(', ')
      },
      roles: {
        dark: ['purple'],
        light: ['purple'],
      },
    },
  },
  fonts: {
    Montserrat: {
      name: 'Montserrat',
      src: 'https://fonts.googleapis.com/css?family=Montserrat',
    },
  },
  setTheme(themeName) {
    hydrogen.dark = themeName === 'dark'
  },
  set(themeName) {
    const colors = Object.keys(hydrogen.colors)

    colors.forEach((name) => {
      const color = hydrogen.colors[name]
      const { roles } = color

      roles[themeName].forEach((r) => {
        hydrogen.themes[themeName][r] = { base: `#${color.hex}` }
      })
    })

    return hydrogen.themes[themeName]
  },
}

// Define themes
hydrogen.set('dark')
hydrogen.set('light')

hydrogen.setTheme('light')

export default hydrogen
